import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import useCart from 'components/CartWidget/useCart';
import { Button } from 'components/Button';
import Counter from './Counter';

import './index.sass'

const { block, el, cnBlock } = bem('cart-button');

export default ({ id, amount, maxAmount, soonActive }) => {

    const { updateItem } = useCart(id);

    const disabled = maxAmount <= 0 || soonActive;

    const onButtonClick = (e) => {
        e.preventDefault();
        if (maxAmount <= 0 || soonActive) {
            return;
        }
        updateItem();
    }

    const text = () => {
        if (soonActive) {
            return 'Скоро в продаже'
        }
        if (maxAmount <= 0) {
            return 'Продано'
        }
        return 'В корзину'
    }

    if (amount > 0) {
        return <Counter amount={ amount } maxAmount={ maxAmount } updateItem={ updateItem }/>
    }

    return <Button mod={ 'gold' }
                   disabled={ disabled }
                   className={ block({ disabled }) }
                   onClick={ onButtonClick }>
        <Text>{ text() }</Text>
        { !disabled && <Icon name={ 'shopping-cart' }/> }
    </Button>
}
